import React, {useEffect, useState, useRef} from "react";
import "./style.css";
import ScaleLoader from "react-spinners/ScaleLoader"; 
import {
    BsPlayCircleFill, 
    BsStopCircleFill, 
    BsFacebook,
    BsWhatsapp,
    BsInstagram,
    BsYoutube,
    BsTwitterX
} from "react-icons/bs";
import { TbAntennaBars1 } from "react-icons/tb";
import Lottie from "lottie-react";
import animationWave from "../../assets/lottie/animation.json";
import MediaSession from '@mebtte/react-media-session';

const Home = () => {
    const [radioStarted, setRadioStarted] = useState(false);
    const [musicName, setMusicName] = useState("");
    const animationRef = useRef(null);

    const toogleRadioStarted = () => {
        setRadioStarted(radioStarted => ! radioStarted);

        if (radioStarted)
            setMusicName("");
    }

    const handleMusicName = async () => {
        return; //
        if (radioStarted)
            fetch("https://icaracing.ddns.net/tools/api/radio-tks", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                }            
            })
            .then((response) => response.json())
            .then((data) => {
                setMusicName(data.musicName);
            })
            .catch(() => {
                //                
            }); 
        else 
            setMusicName("");
    }   

    useEffect(() => {
        const intervalMusicName = setInterval(handleMusicName, 5000);

        if (radioStarted)
            animationRef.current.play();
        else
            animationRef.current.stop();

        return () => clearInterval(intervalMusicName);
    }, [radioStarted]);

    useEffect(() => {
        setTimeout(() => setRadioStarted(true), 1000);
    }, []);

    return (
        <>
            <div className="home-container">
                <div className="home-topo">
                    <div className="home-botao">
                        <BsWhatsapp size={28} color="white" onClick={() => window.open("https://api.whatsapp.com/send?phone=5551994404175")} />                           
                    </div>  

                    <div className="home-botao">
                        <BsFacebook size={28} color="white" onClick={() => window.open("https://www.facebook.com/tukasantos.tks/")} />                           
                    </div>

                    <div className="home-botao">
                        <BsInstagram size={28} color="white" onClick={() => window.open("https://www.instagram.com/radiotks/")} />                           
                    </div>                       

                    <div className="home-botao">
                        <BsTwitterX size={28} color="white" onClick={() => window.open("https://twitter.com/TukaSantos")} />                           
                    </div>  

                    <div className="home-botao">
                        <BsYoutube size={28} color="white" onClick={() => window.open("https://www.youtube.com/channel/UCmDuhfq64AfXYGXDVVt13gQ")} />                           
                    </div>
                </div>
                <div className="home-main">
                    <img className="home-logo" alt="logo" src={require("../../assets/img/logo.png")} />

                    <div className="home-musica-container">
                        {/* {radioStarted 
                        ?
                        <ScaleLoader color="gainsboro" />
                        :
                        <TbAntennaBars1 size={39} color="white" />
                        } */}

                        <Lottie 
                            lottieRef={animationRef} 
                            animationData={animationWave} 
                            autoplay={false}
                            className="home-animation"
                        />

                        <span className="home-radio-tks">Rádio TKS</span>

                        <span className="home-musica-nome">{radioStarted && musicName ? musicName : "Seja bem vindo!"}</span>
                    </div>
                </div>

                {radioStarted 
                && 
                <audio 
                    autoPlay={true}
                    style={{display: "none"}}
                    data-streaming="https://sv12.hdradios.net:7592/stream"  
                    src="https://sv12.hdradios.net:7592/stream" />
                }

                <div className="home-bottom">
                    <div className="home-botao">
                        {
                            radioStarted
                            ?
                            <BsStopCircleFill size={60} color="white" onClick={toogleRadioStarted} />
                            :
                            <BsPlayCircleFill size={60} color="white" onClick={toogleRadioStarted} />
                        }
                    </div>
                </div>
            </div>

            <MediaSession
                title="Rádio TKS"
                artist={musicName}
                album=""
                artwork={[
                    {
                        src: require("../../assets/img/logo.png"),
                        sizes: "256x256,384x384,512x512",
                        type: "image/png",
                    },
                    {
                        src: require("../../assets/img/logo.png"),
                        sizes: "96x96,128x128,192x192",
                        type: "image/png",
                    },
                ]}
                onPlay={toogleRadioStarted}
                onPause={toogleRadioStarted}
            />            
        </>
    );
};

export default Home;
